import { argbFromHex, hexFromArgb, TonalPalette } from "@material/material-color-utilities";

/**
 * The tone keys the `primary` palette carries, matching what `m3-theme.scss` compiles in and what
 * the API emits.
 */
export const PRIMARY_TONES = [0, 10, 20, 25, 30, 35, 40, 50, 60, 70, 80, 90, 95, 98, 99, 100] as const;

/** The tone that holds the brand color itself. */
export const BRAND_TONE = 50;

/**
 * Generates the `primary` tonal ramp from a single brand hex.
 *
 * Shares its behaviour with `synthesizeThemeVariables` in the API and `tonesFromBrand` in the
 * mobile app; all three are asserted against the same golden values, so they cannot drift apart.
 *
 * Tone 50 is overwritten with the brand color. A tonal ramp normalizes lightness, so its own tone
 * 50 is a dark mid-tone rather than the brand, and every client already reads tone 50 as "the
 * brand color". Pinning a fixed tone like 70 instead would not work, since the production brand
 * colors span tone 49 to 95.
 */
export function tonesFromBrand(brandColor: string): Record<string, string> {
    const argb = argbFromHex(brandColor);
    const palette = TonalPalette.fromInt(argb);

    const tones: Record<string, string> = {};
    for (const tone of PRIMARY_TONES) {
        tones[String(tone)] = hexFromArgb(palette.tone(tone));
    }
    tones[String(BRAND_TONE)] = hexFromArgb(argb);

    return tones;
}
